import { filter, get, isEmpty, size } from 'lodash-es';
import { Frame } from '@marvelapp/core';
import * as imagePreloadingStatus from '../constants/imagePreloading';
import * as marvelURL from '../constants/marvelURL';
import * as platform from '../constants/platform';
import { getSectionID } from './screen';
export function getOverallImageLoadingProgress(state) {
    var imagePreloading = state.imagePreloading;
    var noOfImages = size(imagePreloading);
    var noOfLoadedImages = size(filter(imagePreloading, isLoaded));
    return { noOfImages: noOfImages, noOfLoadedImages: noOfLoadedImages };
}
export function getProjectID(state) {
    return get(state, 'project.config.id');
}
export function getProjectNumericID(state) {
    return get(state, 'project.config.numericID');
}
export function getIsCommentingEnabled(state) {
    return get(state, 'project.config.isCommentingEnabled', false);
}
export function isCentredWebPrototype(state) {
    return state.project.config.centerImage && state.project.config.isWeb;
}
export function getOrientation(state) {
    return state.project.config.device.orientation;
}
export function getFrame(state) {
    if (state.project.frameOverride) {
        return state.project.frameOverride;
    }
    return get(state, 'project.config.device.frame');
}
function isLoaded(status) {
    return status === imagePreloadingStatus.DONE;
}
export function isWeb(state) {
    return state.project.config.isWeb;
}
export function isPro(state) {
    return state.project.config.isPro;
}
export function isEmbedded(state) {
    return state.project.isEmbedded;
}
export function getCompanyColourAndLogo(state) {
    return {
        companyIcon: state.project.config.companyData.loadingScreenIcon,
        companyColour: state.project.config.companyData.loadingScreenColour,
    };
}
export function getPlatform(state) {
    if (isWeb(state)) {
        return platform.WEB;
    }
    if (isAppleWatch(state)) {
        return platform.WATCHOS;
    }
    if (isAndroid(state)) {
        return platform.ANDROID;
    }
    return platform.IOS;
}
export function isAppleWatch(state) {
    var frame = getFrame(state);
    if (!frame) {
        return false;
    }
    return frame.indexOf(Frame.AppleWatch42) !== -1;
}
function isAndroid(state) {
    var frame = getFrame(state);
    if (!frame) {
        return false;
    }
    return frame.indexOf(Frame.Nexus5) !== -1;
}
export function getNoOfScreens(state) {
    if (getSectionID(state)) {
        return getScreenGroups(state).groupedScreens[0].screens.length;
    }
    return get(state, 'project.config.screens', []).length;
}
export function getScreenById(state, id) {
    return get(state, 'project.config.screenMap', {})[id];
}
export function getScreenByIndex(state, index) {
    var sectionID = getSectionID(state);
    return sectionID
        ? getScreenGroups(state).groupedScreens[0].screens[index]
        : get(state, 'project.config.screens', [])[index];
}
export function getScreenOrder(state, screenID) {
    var sectionID = getSectionID(state);
    var screen = getScreenById(state, screenID);
    if (sectionID) {
        var sections = getScreenGroups(state).groupedScreens;
        return screen.order - sections[0].screens[0].order + 1;
    }
    return screen === null || screen === void 0 ? void 0 : screen.order;
}
export function getScreenGroups(state) {
    var _a = state.project.config, _b = _a.groupedScreens, groupedScreens = _b === void 0 ? [] : _b, _c = _a.ungroupedScreens, ungroupedScreens = _c === void 0 ? [] : _c;
    var sectionID = getSectionID(state);
    if (sectionID) {
        return {
            ungroupedScreens: [],
            groupedScreens: groupedScreens.filter(function (_a) {
                var id = _a.id;
                return id === sectionID;
            }),
        };
    }
    return {
        groupedScreens: groupedScreens,
        ungroupedScreens: ungroupedScreens,
    };
}
export function getProjectUrl(state) {
    return get(state, 'project.config.projectUrl', false);
}
export function getScreenUrl(state) {
    var projectUrl = getProjectUrl(state);
    var screenId = get(state, 'screen.currentScreen.id', false);
    if (!screenId) {
        return '';
    }
    return "".concat(projectUrl, "screen/").concat(screenId, "/");
}
export function getUserFlowsUrl(state) {
    return marvelURL.USER_FLOWS + get(state, 'project.config.id');
}
export function getProjectName(state) {
    return get(state, 'project.config.name');
}
export function getOwnerUsername(state) {
    return get(state, 'project.config.ownerUsername');
}
export function getOwnderId(state) {
    return get(state, 'project.config.ownerId');
}
export function getDateModified(state) {
    return new Date(get(state, 'project.config.modifiedDate'));
}
export function getIsEnterprise(state) {
    return get(state, 'project.config.companyData.isEnterprise');
}
export function getIsSlideshowEnabled(state) {
    return (!get(state, 'project.config.isLoading') &&
        (get(state, 'project.config.swipeThroughScreens') ||
            isEmpty(get(state, 'project.config.hotspotMap', {}))));
}
export function getProjectScreens(state) {
    var _a;
    return (_a = state.project) === null || _a === void 0 ? void 0 : _a.config.screens;
}
export function getExternalPrototypeUrl(state) {
    var _a, _b;
    var embedUrl = (_b = (_a = state.project) === null || _a === void 0 ? void 0 : _a.config.externalPrototype) === null || _b === void 0 ? void 0 : _b.embedUrl;
    if (embedUrl &&
        // in Ballpark even Marvel prototypes are external -- the cloned project has
        // externalPrototype set. However, here in the prototype viewer, we only
        // want to treat non-Marvel prototypes as external.
        embedUrl.indexOf('marvelapp') === -1) {
        return embedUrl;
    }
}
